import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import AppMobileLoading from "../../dialog/app_mobile_loading";
import { Button } from "antd";

class ReadDeclaration extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            isPersonToBeCoveredRead: false,
        };
    }

    componentDidMount() {
        const { state } = this.props.location;
        console.log("state", state);
        this.observer.observe(document.querySelector('#end-of-list'));
        if (state?.acknowledgeFiles?.isPersonToBeCoveredRead !== undefined) {
            this.setState({ isPersonToBeCoveredRead: state.acknowledgeFiles.isPersonToBeCoveredRead });
        }
    }

    observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            this.setState({ isPersonToBeCoveredRead: true })
        }
    }, { threshold: 0.1 });

    getLastUrlParam() {
        const url = window.location.href;
        const params = url.split("/");
        return params[params.length - 1];
    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    handleGoBack() {
        const { state } = this?.props?.location;
        console.log("state to pass back:", state);
        this.props.history.push({
            pathname: `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_declaration}/${this.getProposalId()}`,
            state: {
                agreement: {
                    personalInfo: state?.agreement?.personalInfo,
                    shareContact: state?.agreement?.shareContact,
                    shareToThirdParties: state?.agreement?.shareToThirdParties,
                    // readAndAgree: state?.agreement?.readAndAgree,
                    agreeCollectData: state?.agreement?.agreeCollectData,
                    readAndAgree: state?.agreement?.readAndAgree
                },
                acknowledgeFiles: {
                    isImportantNoticRead: state?.acknowledgeFiles?.isImportantNoticRead,
                    isTnCnDCIRead: state?.acknowledgeFiles?.isTnCnDCIRead,
                    isFATCAnCRSDeclareRead: state?.acknowledgeFiles?.isFATCAnCRSDeclareRead,
                    isPersonalDataProtectionNoticeRead: state?.acknowledgeFiles?.isPersonalDataProtectionNoticeRead,
                    isPersonToBeCoveredRead: this?.state?.isPersonToBeCoveredRead, //update PTC read state only
                    isCustomerDeclareRead: state?.acknowledgeFiles?.isCustomerDeclareRead,

                },
            },
        });
    }

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <AppMobileLoading isLoading={this.state.loading} />
            </div>
        );
    }

    handleScroll = (e) => {
        console.log("scroll to end",{
            sh: e.target.scrollHeight,
            ch: e.target.clientHeight,
            st: e.target.scrollTop,
            diff: e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop
        });
        // const bottom = Math.abs(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop) < 1;
        // if (bottom) {
        //     this.setState({ isPersonToBeCoveredRead: true })
        // }
    }

    renderBottomBar() {
        return (
            <div className="bottom_container d-flex justify-content-center">
                <Button
                    disabled={this.state.isPersonToBeCoveredRead ? false : true}
                    style={{
                        backgroundColor: '#183028',
                        color: 'white',
                        width: '100%',
                        height: 49,
                        opacity: this.state.isPersonToBeCoveredRead ? 1 : 0.7
                    }}
                    onClick={() => this.handleGoBack()}
                >
                    Agree
                </Button>
            </div>
        )
    }


    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                <div className="mobile_container" style={{ height: window.innerHeight, }} >
                    <div className="client_header justify-content-between px-4">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Back.svg`
                            }
                            onClick={() => this.handleGoBack()}
                            alt="Documents"
                            className=""
                            style={{ width: 15, height: 15, cursor: 'pointer' }}
                        />
                        Person to be Covered's Declaration
                        <div></div>
                    </div>
                    <div className="d-flex justify-content-center p-4 row w-100 m-0" style={{ height: window.innerHeight * 0.9, overflowY: 'scroll' }} onScroll={(e) => this.handleScroll(e)} ref={this.containerRef} >
                        <div className="mt-2" style={{ paddingBottom: "60px" }}>
                            <div className=" client_instruction_text">
                                <b>Declarations Made by Person to be Covered </b>
                                <div className="mt-2" >
                                    I declare and agree on behalf of myself and any person or persons, firm or corporation, who may have or claim any interest in this application form, that:
                                    <div className="pt-3">
                                        <ol className="px-3" type="1" style={{ textAlign: 'justify' }}>
                                            <li className="mb-3">I have been provided with the Product Disclosure Sheet and Benefit Illustration by FWD Takaful’s authorised representative, and I fully understood the contents of the Product Disclosure Sheet and Benefit Illustration as explained to me by FWD Takaful’s authorised representative; and my particular attention has been drawn to the essential information of the major features and limitations of which have been satisfactorily explained to me.</li>
                                            <li className="mb-3">
                                                I declare that:
                                                <ol className="px-3" type="a">
                                                    <li className="mb-3">I am aware that it is my pre-contractual duty of disclosure that I must exercise reasonable care not to misrepresent i.e. to give false answers and/or information when answering any questions asked by FWD Takaful and that I have  to answer the questions fully and accurately and/or correctly;</li>
                                                    <li className="mb-3">I have fully and accurately answered all the questions in this application form and the other questions asked by FWD Takaful, if any, after having fully read and understood the questions;</li>
                                                    <li className="mb-3">I am aware that I must inform FWD Takaful of any change to the answers given in this application form if the change occurs after I have submitted this application form but before the Takaful contract is entered into;</li>
                                                    <li className="mb-3">I fully understand that my answers and/or statements given in response to FWD Takaful's questions, and any other relevant documents completed by me in connection with this application form and in any medical report or amendments are relevant to FWD Takaful in determining whether or not to accept my application form, rates and terms to be applied; and </li>
                                                    <li className="mb-3">I am aware that if the information given by me is incorrect or not accurate, the Takaful Certificate may be voided or terminated, my claim may be denied or reduced, or the terms of the Takaful Certificate changed or varied.</li>
                                                </ol>
                                            </li>
                                            <li className="mb-3">I will keep FWD Takaful updated of any change to my personal information as soon as practicable.</li>
                                            <li className="mb-3">I agree that neither FWD Takaful nor its employees shall be liable for any direct or indirect loss or damage due to my inaccuracy or incompleteness in the personal information provided to FWD Takaful, which includes but is not limited to personal details of transactions with or through FWD Takaful, whether within or outside Malaysia, involving any party.</li>
                                            <li className="mb-3">I confirm that this application form is independent of any statement made by your intermediary named below to whom I have given no other information, except those stated in this application form, and that to the best of my knowledge and belief, your said intermediary has given no other information, relating to any circumstances relevant to the acceptance of the risk. I further acknowledge that all the terms and conditions have been fully explained to me and the answers provided are the actual information disclosed by me.</li>
                                            <li className="mb-3">I understand that upon receipt of the Takaful Certificate from FWD Takaful, I will have a 15-day free look period to evaluate the suitability of the plan participated in. In the event that I wish to cancel the Takaful Certificate during this period, I may do so by giving FWD Takaful written notice of my intention to cancel.</li>
                                            <li className="mb-3">
                                                FWD Takaful will refund:
                                                <ol type="a" className="px-3">
                                                    <li className="mb-3">my contribution to me or Master Certificate Owner, whichever is applicable (if payment was made before the Takaful Certificate Schedule was issued), less any fees for medical examination FWD Takaful may have incurred, if I withdraw my consent before the Takaful application is accepted by FWD Takaful.</li>
                                                    <li className="mb-3">my contribution paid to Master Certificate Owner less any fees for medical examination FWD Takaful may have incurred upon cancellation of Takaful Certificate Schedule during 15-day free look period after the Takaful Certificate Schedule has been issued.</li>
                                                </ol>
                                            </li>
                                            <li className="mb-3">I understand that upon early settlement of business financing before coverage expiry date, I may surrender the certificate to receive the Surrender Value as stated in the Takaful Certificate Schedule.</li>
                                            <li className="mb-3">I agree that in the event of surrender, any unutilized portion of the contribution allocated in the Participants' Risk Fund will be refunded to me  . If FWD Takaful does not have my bank account details and after exhausting its effort to reach out to me, FWD Takaful will transfer it to the Registrar of Unclaimed Moneys. I will not be able to reinstate (restart) the certificate after I cancel it. </li>
                                            <li className="mb-3">I understand that the coverage will only be effective upon receipt of the appropriate Takaful Contribution payment and approval by FWD Takaful of this application and the relevant Takaful Certificate is issued and delivered to me pursuant to this application during my lifetime and in good health. (Please ensure you receive and will be keeping the receipt of payment from FWD Takaful or your Family Takaful Certificate (as the case may be) as proof of Takaful Contribution(s) payment).</li>
                                            <li className="mb-3">I agree that an interim accidental death benefit will be provided to all eligible participants in the event that the contribution has been paid in full, but the certificate has yet to be effective. I understand that the interim accidental death benefit is based on the sum covered chosen and subject to the maximum amount set for this benefit.</li>
                                            <li className="mb-3">I agree to appoint FWD Takaful based on the Wakalah (agency) principle to manage my Takaful Contribution(s) in the Participants’ Risk Fund (PRF) and the relevant participants’ funds (if applicable) in accordance with Shariah principles. </li>
                                            <li className="mb-3">I agree to allow FWD Takaful to delegate part of its role to a sub agent and I also agree to allow FWD Takaful to appoint a sub agent, where appropriate.</li>
                                            <li className="mb-3">I/We allow FWD Takaful to deduct Wakalah (agency) fee for the services rendered and any other charges as stipulated in the Benefit Illustration and Takaful Schedule.  </li>
                                            <li className="mb-3">I agree that any distributable Surplus will be shared between eligible participants and FWD Takaful in the ratio of 50:50. FWD Takaful will allocate my entitlement of participants' distributable Surplus and payable on expiry date of the Takaful Certificate Schedule or at point of surrender or claim payment of the benefits, whichever occurs first.</li>
                                            <li className="mb-3">At the end of each financial year, FWD Takaful will calculate whether there is any Surplus remaining in the Participants' Risk Fund (PRF) after paying any Qard. FWD Takaful may decide to retain some of that Surplus in the PRF in case future claims paid are higher than expected.</li>
                                            <li className="mb-3">If the PRF is in a deficit, FWD Takaful will overcome the deficit in the form of a Qard or an interest-free loan. The payment of Qard will be from the shareholder's fund.</li>
                                            <li className="mb-3">
                                                I agree that FWD Takaful has the right to freeze or seize any monies received or payable under my certificate:
                                                <ol type="a" className="px-3">
                                                    <li className="mb-3">at the order of the relevant authorities; or</li>
                                                    <li className="mb-3">if FWD Takaful discovers, or if FWD Takaful has reasonable suspicion that, I am sanctioned under any competent authorities recognised by FWD Takaful, for money laundering activities relating to financing terrorism; under the Anti-Money Laundering, Anti-Terrorism Financing and Proceeds of Unlawful Activities Act 2001.</li>
                                                </ol>
                                            </li>
                                        </ol>
                                        <div className="mt-3">If this happens, FWD Takaful is entitled to end my certificate and its coverage immediately. FWD Takaful will deal with all contributions paid and all amounts payable under my certificate in any manner that they deem fit, which may include handing it over to the relevant authorities.</div>
                                        <div id="end-of-list" style={{ height: '50px' }}></div>
                                    </div>
                                </div>
                                {/* <ol>
                                    {
                                        Config.client.declaration.map((data) => {
                                            return (
                                                <li className="mt-3">
                                                    {data}
                                                </li>
                                            )
                                        })
                                    }

                                </ol> */}
                            </div>

                        </div>
                    </div>
                    {this.renderBottomBar()}

                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ReadDeclaration));
